module.exports = __webpack_public_path__ + "resource/img/Dangerous.ed8b4b7e.png";